import { isConsulFlagEnabled } from "../../utils/Helpers";

const features = {
  isBusinessOperationAgentEnabled: () => isConsulFlagEnabled("BUSINESS_OPERATION_AGENT_ENABLED"),
};

export default features;
